import { lazy } from 'react';
import { createRouteItem } from 'utils/navigation';
import { MENU_KEYS, SCREENS_KEYS } from 'constants/constants';
import type { RouterType } from 'commons/modules/routers/routes';

const OnboardingMoralPersonView = lazy(
  () => import('views/NewClient/Onboarding/MoralPerson'),
);

const routers: RouterType[] = [
  {
    exact: true,
    path: '/clientes/moral/nuevo',
    component: OnboardingMoralPersonView,
    fallback: '/clientes/moral/nuevo',
    menuKey: MENU_KEYS.clients,
    screenKey: SCREENS_KEYS.onboarding,
    breadcrumbs: {
      title: 'Nuevo Cliente',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Crear cliente', '/clientes/nuevo'),
      ],
    },
  },
  {
    exact: true,
    path: '/clientes/moral/:clientId',
    component: OnboardingMoralPersonView,
    fallback: '/clientes/moral/:clientId',
    menuKey: MENU_KEYS.clients,
    screenKey: SCREENS_KEYS.onboarding,
    breadcrumbs: {
      title: 'Nuevo Cliente',
      routes: [
        createRouteItem('Home', '/'),
        createRouteItem('Crear cliente', '/clientes/nuevo'),
      ],
    },
  },
];

export default routers;
